<template>
  <SubDeviceDetail :is-edit="true"/>
</template>

<script>
import SubDeviceDetail from './detail';

export default {
  name: "SubDeviceEdit",
  components: { SubDeviceDetail },
}
</script>

<style scoped>

</style>
